import { tGameType } from 'common/modules/ReactShared';
import { useMemo } from 'react';

// test game config
// TODO: Take it from backend in future
interface IGameConfig {
  maxRounds: number;
  difficulty: 'easy' | 'medium' | 'hard';
  showTutorial?: boolean;
}

const gamesConfigMap = new Map<tGameType, IGameConfig>([
  ['flashcard', { maxRounds: 30, difficulty: 'easy' }],
  ['waterfall', { maxRounds: 4, difficulty: 'easy' }],
  ['match', { maxRounds: 6, difficulty: 'easy' }]
  // ['nodes', { maxRounds: 6, difficulty: 'easy', showTutorial: true }]
]);

interface IGame {
  config?: IGameConfig;
}

const useTaskGameConfig = (gameType: tGameType): IGame | null => {
  const game = useMemo(() => {
    if (!gameType) return null;
    const config = gamesConfigMap.get(gameType);

    return { config };
  }, [gameType]);

  return game;
};

export { useTaskGameConfig, gamesConfigMap };
export type { IGameConfig, IGame };
